import React, { createContext, useCallback, useContext } from 'react';
import { toast } from 'sonner';

type ToasterCtx = { notify: (title: string, body?: string, bg?: string) => void };

const Ctx = createContext<ToasterCtx>({ notify: () => {} });

export const ToasterProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const notify = useCallback((title: string, body?: string, bg?: string) => {
    const message = body ? `${title}: ${body}` : title;
    
    switch (bg) {
      case 'success':
        toast.success(message);
        break;
      case 'danger':
        toast.error(message);
        break;
      case 'warning':
        toast.warning(message);
        break;
      default:
        toast(message);
        break;
    }
  }, []);

  return (
    <Ctx.Provider value={{ notify }}>
      {children}
    </Ctx.Provider>
  );
};

export const useToaster = () => useContext(Ctx);
